import { Link } from 'react-router-dom';

export interface BreadcrumbItem {
  label: string;
  href: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航">
      <ol className="flex items-center flex-wrap gap-2 text-sm">
        <li>
          <Link to="/" className="text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={item.href} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-foreground-400 text-xs"></i>
            {index === items.length - 1 ? (
              <span className="text-foreground-800 font-medium whitespace-nowrap">{item.label}</span>
            ) : (
              <Link to={item.href} className="text-foreground-500 hover:text-foreground-800 transition-colors whitespace-nowrap cursor-pointer">
                {item.label}
              </Link>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}